import React from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash-es'

import NameAvatar from 'syft-acp-core/components/NameAvatar'
import { cellPropTypes, cellDefaultProps } from '../dataProps'
import { emptyTextFallback } from './fallback'
import { colPlaceholderFactory } from '../../../placeholders/factory'

import './AcpCellWorker.css'

// Returns the employer's company name.
const formatCompanyName = employer => {
  if (!employer) return null
  if (employer.brand_name) return employer.brand_name
  if (employer.company_name) return employer.company_name
  return null
}

// Column placeholder component.
export const AcpColEmployer = colPlaceholderFactory('AcpCellEmployer')

/**
 * Component for displaying a worker's name and avatar.
 * Takes an object like { brand_name: 'a', company_name: 'b', employer_id: 1, picture: { uuid: 'c' } }
 *
 *    <Acp.Col.Employer value="employer" header="Worker" isMinimal />
 *
 * If the 'picture' data is not present, a guest avatar will be displayed instead.
 */
export default class AcpCellEmployer extends React.PureComponent {
  static propTypes = {
    ...cellPropTypes,
    value: PropTypes.shape({
      brand_name: PropTypes.string,
      company_name: PropTypes.string,
      employer_id: PropTypes.number,
      picture: PropTypes.shape({
        uuid: PropTypes.string,
      }),
    }),
    options: PropTypes.shape({
      hideAvatar: PropTypes.bool,
    }).isRequired,
  }

  static defaultProps = {
    ...cellDefaultProps,
  }

  render() {
    const { value, options } = this.props
    const avatarData = get(value, 'picture', false)
    const avatarUUID = get(avatarData, 'uuid', null)
    const companyName = formatCompanyName(value)

    const hideAvatar = get(options, 'hideAvatar', false)

    // Normally we never break a user's name. This can be adjusted.
    const useWrapping = get(options, 'useWrapping', false)

    // If we have a worker name, but no avatar UUID, display the guest avatar.
    const isGuest = companyName != null && companyName !== '' && avatarUUID == null

    return (
      <div className="acp-cell-worker">
        <NameAvatar
          hideAvatar={hideAvatar}
          userName={companyName || `\u00A0${emptyTextFallback}`}
          userUUID={avatarUUID}
          useGuestAvatar={isGuest}
          useWrapping={useWrapping}
        />
      </div>
    )
  }
}
